import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-shared-layout',
    templateUrl: './shared-layout.component.html',
    styleUrls: ['./shared-layout.component.scss'],
    standalone: false
})
export class SharedLayoutComponent<T extends string> {
  //#region Style Inputs
  @Input() leftSidebarWidth = '350px';
  //#endregion Style Inputs
  @Input() tabs: T[] = [];
  @Input() selectedTab: T | null = null;
  @Output() readonly selectedTabChange = new EventEmitter<T>();

  protected onSelectedTabChange(tab: T): void {
    this.selectedTabChange.emit(tab);
  }

  protected trackTabByTabName(_: number, tab: T): T {
    return tab;
  }
}
